import { render, staticRenderFns } from "./FolderDropzone.vue?vue&type=template&id=4a0fac94&"
import script from "./FolderDropzone.vue?vue&type=script&lang=js&"
export * from "./FolderDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports